import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      alignItems: "center",
      border: "1px solid #B9BEC7",
      borderRadius: "8px",
      padding: "20px 16px 20px 24px",
      width: "215px",
      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04)",
      background: "white",
    },

    innerContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      alignItems: "flex-start",
      alignSelf: "stretch",
      gap: "10px",
    },

    title: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "14px",
      color: "#8B95A6",
    },
    value: {
      fontSize: "24px",
      fontWeight: "700",
      lineHeight: "24px",
      textTransform: "uppercase",
      color: "black",
    },
  })();
};
